import React, { useState } from 'react';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { isPolishPhone } from './motorForm';
import { submitLead } from './submitLead';

// Port usppublicsite/src/components/sections/CallbackCTA.tsx (stały temat).
const PHONE = '+48 605 308 400';
const PHONE_HREF = 'tel:+48605308400';

const CallbackCTA = ({ title, lede, topic }) => {
  const { executeRecaptcha } = useGoogleReCaptcha();
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [consent, setConsent] = useState(false);
  const [err, setErr] = useState({});
  const [done, setDone] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    const next = {};
    if (!name.trim()) next.name = 'Podaj imię.';
    if (!isPolishPhone(phone.trim()))
      next.phone = 'Podaj polski numer telefonu (9 cyfr, opcjonalnie z +48).';
    if (!consent) next.consent = 'Zaznacz zgodę, aby wysłać.';
    setErr(next);
    if (Object.keys(next).length > 0) return;

    setSubmitting(true);
    setSubmitError(null);
    try {
      await submitLead(executeRecaptcha, {
        fullName: name.trim(),
        phone: phone.trim(),
        email: '',
        message: `<b>Prośba o oddzwonienie</b> — ${topic}`,
        subject:
          'Prośba o oddzwonienie - Ubezpieczenie Twojego Auta - Pakiety Dealerskie'
      });
      setDone(true);
    } catch (error) {
      setSubmitError('Coś poszło nie tak. Spróbuj jeszcze raz.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section className="cb-sec" id="oddzwonimy">
      <div className="cb-in">
        <div>
          <span className="k-eyebrow on-dark">Porozmawiajmy</span>
          <h2 className="cb-title">{title}</h2>
          <p className="cb-lede">{lede}</p>
          <div className="cb-phone-row">
            <span className="cb-or">lub zadzwoń</span>
            <a href={PHONE_HREF} className="cb-phone">
              {PHONE}
            </a>
          </div>
        </div>

        <div className="cb-formwrap">
          {done ? (
            <div className="cb-ok" role="status" aria-live="polite">
              <span className="cb-ok-mark" aria-hidden>
                ✓
              </span>
              <h3>Dziękujemy!</h3>
              <p>Oddzwonimy w godzinach pracy biura (8:00–16:00).</p>
            </div>
          ) : (
            <form className="cb-form" onSubmit={submit} noValidate>
              <label className="cb-field" htmlFor="cb-name">
                <span className="cb-label">Imię</span>
                <input
                  id="cb-name"
                  type="text"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  className={err.name ? 'mq-err' : ''}
                  placeholder="Jan"
                  autoComplete="given-name"
                  required
                />
                {err.name && <span className="mq-field-err">{err.name}</span>}
              </label>
              <label className="cb-field" htmlFor="cb-phone">
                <span className="cb-label">Numer telefonu</span>
                <input
                  id="cb-phone"
                  type="tel"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                  className={err.phone ? 'mq-err' : ''}
                  placeholder="+48 ___ ___ ___"
                  autoComplete="tel"
                  inputMode="tel"
                  required
                />
                {err.phone && <span className="mq-field-err">{err.phone}</span>}
              </label>
              <label
                className={`cb-consent ${err.consent ? 'mq-consent-err' : ''}`}
              >
                <input
                  type="checkbox"
                  checked={consent}
                  onChange={(e) => setConsent(e.target.checked)}
                  required
                />
                <span>
                  Wyrażam zgodę na kontakt telefoniczny w celu przedstawienia
                  oferty.
                </span>
              </label>
              {err.consent && (
                <span className="mq-field-err">{err.consent}</span>
              )}
              {submitError && (
                <p className="mq-err-summary" role="alert">
                  {submitError}
                </p>
              )}
              <button
                type="submit"
                className="k-btn k-btn-primary k-btn-block cb-submit"
                disabled={submitting}
                data-product-cta
              >
                {submitting ? 'Wysyłanie…' : 'Zamów rozmowę'}
                <span className="k-arrow" aria-hidden>
                  →
                </span>
              </button>
            </form>
          )}
        </div>
      </div>
    </section>
  );
};

export default CallbackCTA;
